// LIBRARIES
import { BrowserRouter } from "react-router-dom";

// COMPONENTS
import AppRoutes from "./config/AppRoutes";
import ModalAtom from "components/Atoms/ModalAtom/ModalAtom";
import SnackbarAtom from "components/Atoms/SnackbarAtom/SnackbarAtom";

const App = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
      <ModalAtom />
      <SnackbarAtom />
    </BrowserRouter>
  );
};

export default App;
